module.exports = __webpack_public_path__ + "img/bg2.22661e81.jpg";